import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg viewBox="0 0 150 150" {...props}>
    <defs>
      <path id="mps-a" d="M0 6V0h6v6H0zm2.59-1.252h.82V1.252h-.82v3.496z" />
      <path
        id="mps-c"
        d="M0 6V0h6v6H0zm1.718-4.748v3.496h.822V3.613h1.512V2.79H2.54v-.717h1.823v-.822H1.718z"
      />
      <path id="mps-e" d="M0 6V0h6v6H0zm2.59-1.252h.82V1.252h-.82v3.496z" />
      <path
        id="mps-g"
        d="M0 6V0h6v6H0zm1.425-4.748v3.496h1.403a1.748 1.748 0 1 0 0-3.496H1.425zM3.753 3a.926.926 0 0 1-.925.926h-.581V2.074h.58c.512 0 .926.415.926.926z"
      />
      <path
        id="mps-i"
        d="M0 6V0h6v6H0zm2.993-4.787c-1 0-1.81.805-1.81 1.799 0 .993.81 1.798 1.81 1.798s1.81-.805 1.81-1.798c0-.994-.81-1.799-1.81-1.799zm0 2.782a.987.987 0 0 1-.99-.983c0-.544.444-.984.99-.984.547 0 .99.44.99.984a.987.987 0 0 1-.99.983z"
      />
      <path
        id="mps-k"
        d="M0 6V0h6v6H0zm3.803-4.748L3 3.518l-.803-2.266H1.162v3.496h.822V3.11l.58 1.637h.872l.58-1.637v1.637h.822V1.252H3.803z"
      />
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(10 34)">
      <path fill="#15539F" stroke="#FFF" strokeWidth="3" d="M92.5 6.026H58.71v33.789H92.5z" />
      <path
        fill="#7BB835"
        stroke="#FFF"
        strokeWidth="3"
        d="M71.526-.984H37.718v33.808h33.808V-.984z"
      />
      <path fill="#53A2D9" stroke="#FFF" strokeWidth="3" d="M50.763 6.026h-33.79v33.789h33.79z" />
      <path
        fill="#FFF"
        stroke="#51565C"
        strokeWidth="3.5"
        d="M101.947 18.474H6.842V81.42h95.105z"
      />
      <path fill="#FFF" stroke="#51565C" strokeWidth="3.5" d="M35.975 42.242H.302v22.32h35.673z" />
      <circle cx="24.526" cy="53.947" r="4" fill="#51565C" transform="matrix(-1 0 0 1 49.053 0)" />
      <path stroke="#51565C" strokeWidth="4" d="M103.024 31.474H6.804" />
      <path
        fill="#51565C"
        fillRule="nonzero"
        stroke="#FFF"
        strokeWidth="2"
        d="M121.468 68.737H83.842v-6.105h38.165l-9.17-10.262 4.263-3.864 13.364 14.952a2.89 2.89 0 0 1 0 3.85L117.1 82.258l-4.264-3.864 8.632-9.658z"
      />
      <g transform="translate(76.979 50.632)">
        <mask id="mps-b" fill="#fff">
          <use href="#mps-a" />
        </mask>
        <use fill="#1251A0" href="#mps-a" />
        <g fill="#15539F" mask="url(#mps-b)">
          <path d="M0 0h6v6H0z" />
        </g>
      </g>
      <g transform="translate(70.615 50.632)">
        <mask id="mps-d" fill="#fff">
          <use href="#mps-c" />
        </mask>
        <use fill="#1251A0" href="#mps-c" />
        <g fill="#15539F" mask="url(#mps-d)">
          <path d="M0 0h6v6H0z" />
        </g>
      </g>
      <g transform="translate(64.25 50.632)">
        <mask id="mps-f" fill="#fff">
          <use href="#mps-e" />
        </mask>
        <use fill="#1251A0" href="#mps-e" />
        <g fill="#7BB835" mask="url(#mps-f)">
          <path d="M0 0h6v6H0z" />
        </g>
      </g>
      <g transform="translate(57.886 50.632)">
        <mask id="mps-h" fill="#fff">
          <use href="#mps-g" />
        </mask>
        <use fill="#7BB934" href="#mps-g" />
        <g fill="#7BB835" mask="url(#mps-h)">
          <path d="M0 0h6v6H0z" />
        </g>
      </g>
      <g transform="translate(51.522 50.632)">
        <mask id="mps-j" fill="#fff">
          <use href="#mps-i" />
        </mask>
        <use fill="#51A2DA" href="#mps-i" />
        <g fill="#53A2D9" mask="url(#mps-j)">
          <path d="M0 0h6v6H0z" />
        </g>
      </g>
      <g transform="translate(45.158 50.632)">
        <mask id="mps-l" fill="#fff">
          <use href="#mps-k" />
        </mask>
        <use fill="#51A2DA" href="#mps-k" />
        <g fill="#53A2D9" mask="url(#mps-l)">
          <path d="M0 0h6v6H0z" />
        </g>
      </g>
    </g>
  </Svg>
)
